import React, { Suspense, useEffect, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-confirm-alert/src/react-confirm-alert.css'
import './App.css'
import SideBar from "./pages/mainsidebar/Sidebar";
import ProtectedRoute from "./components/protectedroute/Protectedroute";
import { Route,Routes, useLocation, useNavigate } from "react-router-dom";
import "antd/dist/reset.css";
import Leave from "./pages/leavescreen/Leave";
import ListView from "./pages/subordinatesscreen/Listview";
import Approvals from "./pages/approvals/Approvals";
import Mainpage from "./pages/consolescreen/Mainpage";
import { useDispatch } from "react-redux";
import { setTrackHRData } from "./Redux/features/trackhrdataslice";
import axios from "axios";
import KeepAliveWrapper from "./pages/KeepAliveWrapper";
import { useAliveController } from 'react-activation';
import { setAliveController } from './utility/aliveController';
import withRouter from "./utility/withRouter";
import Addticket from "./pages/addticket/AddticketV2";
import useInternetcheck from "./customhooks/useInternetcheck";
import { IoMdRefreshCircle } from "react-icons/io";
import logoimg from './assets/logotrackhr.png'
import { toast, ToastContainer } from "react-toastify";
import Loader from "./components/loader/Loader";
import DynamicReportWrapper from "./components/DynamicReportWrapper";
import Meetings from "./pages/meeting/Meetings";
import { getlinks } from "./pages/mainsidebar/getlinks";
import { Modal } from "react-bootstrap";
import { ViewComponent } from "./components/attachment/ViewComponent";
import { routelinks } from "./utility/routelinks";
import { Modal as AntModal } from "antd";
import Editmeeting from "./pages/meeting/addmeeting/Editmeeting";
import Settings from "./pages/console/orgsetting/Settings";
import AttendanceCalendar from "./pages/Attendence";
import AddTeamQrModal from "./pages/addteam/Addteamqrmodal";
const ShiftManagement = React.lazy(()=>import("./pages/console/shiftmanagement/ShiftManagement"))
const Shiftmaster =React.lazy(()=>import("./pages/console/shiftmaster/Shiftmaster"));
const TicketNew = React.lazy(()=>import("./pages/Ticketdiv/Tickets"));
const ExpenseScreen  = React.lazy(()=>import("./pages/passscreen/ExpenseScreen"));
const Mypayslips  = React.lazy(()=>import("./pages/mypayslip/Mypayslips"));
const Redflag  = React.lazy(()=>import("./pages/redflag/Redflags"));
const Locationtimeline = React.lazy(()=>import("./pages/locationtimeline/Locationtimeline"))
const Approvermanagement = React.lazy(()=>import("./pages/approvermanagement/Approvermanagement"))
const Livelocationsummary = React.lazy(()=>import("./pages/Locationsummary/Locationsummary"))
const LeaderboardReport = React.lazy(()=>import("./pages/reportscreen/LeaderboardReport/Leaderboradreport"))
const TaskcoastingReport = React.lazy(()=>import("./pages/reportscreen/TaskcoasingReport/Taskcoastingreport"))
const DailyworkReport = React.lazy(()=>import("./pages/reportscreen/dailyworkreport/DailyworkReport"))
const Tasktimingreport = React.lazy(()=>import("./pages/reportscreen/TaskTimingReport/Tasktimingreport"))
const CalendarReport = React.lazy(()=>import("./pages/reportscreen/CalendarReport"))
const KpiList = React.lazy(()=>import("./pages/kpiscreens/kpilist/KpiList"))
const Userconfig = React.lazy(()=>import("./pages/console/userconfig/Userconfig"))
const KpiAdd = React.lazy(()=>import("./pages/kpiscreens/kpiadd/Kpiadd"))
const Kpidetails = React.lazy(()=>import("./pages/kpiscreens/kpidetails/Kpiinfo"))
const Kpipendency = React.lazy(()=>import("./pages/kpiscreens/kpipendency/Kpipendency"))
const Livelocationsetting = React.lazy(()=> import ("./pages/console/livelocationsetting/Livelocationsetting"))
const Home = React.lazy(() => import("./pages/homescreen/Home"));
const UserProfile = React.lazy(() => import("./pages/userprofile/Userprofile"));
const Loginpage = React.lazy(() => import("./pages/loginpage/Loginpage"));
const Referscreen = React.lazy(() => import("./pages/referscreen/Referscreen"));
const Tutorialscreen = React.lazy(() => import("./pages/tutorialscreen/Tutorialscreen"));
const Activities = React.lazy(() => import("./pages/activityscreen/activitylist/Activities"));
const History = React.lazy(() => import("./pages/activityscreen/activityhistory/History"));
const Todomain = React.lazy(() => import("./pages/todo/Todomain"));
const Hierarchy = React.lazy(()=>import("./pages/hierarchy/Hierarchy"))
const Rightsmanagement = React.lazy(()=>import("./pages/console/rightsmanagement/Employees"))
const Holiday = React.lazy(()=>import("./pages/console/holiday/Holiday"))
const Groupmaster = React.lazy(()=>import("./pages/console/groupmaster/Groupmaster"))
const Bulkmaster = React.lazy(()=>import("./pages/console/bulkmaster/Bulkmaster"))
const Workhistory = React.lazy(()=>import("./pages/workhistory/Workhistory"))
const Broadcasts = React.lazy(()=>import("./pages/broadcast/Broadcasts"))
const Dashboardmain = React.lazy(()=>import("./pages/payroll/Dashboardmain"));
const Allreports = React.lazy(()=>import("./pages/reportscreen/Allreports"))
const AttendanceMachine = React.lazy(()=>import("./pages/console/ams/AttendanceMachine"))
const Addactivity = React.lazy(()=>import("./pages/activityscreen/addactivity/ActivityForm"))
const LeaderboardReportWithRouter = withRouter(LeaderboardReport);
const DailyWorkReportWithRouter = withRouter(DailyworkReport);
const TasktimingreportWithRouter = withRouter(Tasktimingreport);
const TaskcoastingReportWithRouter = withRouter(TaskcoastingReport);
const BroadcastsWithRouter = withRouter(Broadcasts);
const Addmeeting = React.lazy(()=>import("./pages/meeting/addmeeting/Addmeeting"))

function App() {

const navigate = useNavigate()
const dispatch = useDispatch();
const [ismeeting,setismeeting]=useState(false)
const [meetinginfo,setmeetinginfo]=useState(null)
const [isloading,setisloading]=useState(false)
const [isviewattachment,setisviewattachment]=useState(false)
const [attachmentdata,setattachmentdata]=useState(null)
const [showQrModal, setShowQrModal] = useState(false);
const [qrData, setQrData] = useState("");

  useEffect(() => {
    axios.get("./Apiinfo.json").then(res => {
        console.log(res.data.apipathurl,"data")
        if(res.data && res.data?.colors && res.data?.apipathurl){
           dispatch(setTrackHRData(res.data));
        }
      })
      .catch(err => console.error(err))
  }, []);

useEffect(()=>{
console.log(attachmentdata,"attachmentdata")
if(attachmentdata != null){
  setisviewattachment(true)
}
},[attachmentdata])


useEffect(() => {
  const handler = (event) => {
    if (event.data.type == "NAVIGATE") {
        getlinks(navigate,event.data.path,setisloading, setattachmentdata,"",setismeeting,setmeetinginfo,setShowQrModal, setQrData)
    }
  };

  window.addEventListener("message", handler);
  return () => window.removeEventListener("message", handler);
}, []);
useEffect(() => {

  let routelink = routelinks();

  const convertLinks = (root = document) => {
    root.querySelectorAll?.("a[href]").forEach((el) => {

      const href = el.getAttribute("href");
      if (!href) return;

      const shouldConvert = routelink.some(route => href.includes(route));

      if (shouldConvert) {
        el.setAttribute("data-href", href);
        el.removeAttribute("href");
      }

    });
  };

  convertLinks();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {

      if (mutation.type === "attributes") {
        convertLinks(mutation.target);
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          convertLinks(node);
        }
      });

    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["href"]
  });

  const handleClick = (e) => {
    const link = e.target.closest("[data-href]");
    if (link) {
      const divContent = link.closest("div")?.innerText.trim();
      e.preventDefault();

      const href = link.dataset.href;
      getlinks(navigate, href, setisloading, setattachmentdata, divContent,setismeeting,setmeetinginfo,setShowQrModal, setQrData);
    }
  };

  document.addEventListener("click", handleClick);

  return () => {
    observer.disconnect();
    document.removeEventListener("click", handleClick);
  };

}, []);

  const controller = useAliveController();
  useEffect(() => {
    setAliveController(controller);
  }, [controller]);
  const location = useLocation()
const handleRetry = () => {
    window.location.reload();
  };

const useInternet=useInternetcheck()

  useEffect(()=>{

    if(document.visibilityState == "hidden" ) return
  if (!useInternet) {
    toast.warn(
      <div style={{ display: "flex", alignItems: "center", justifyContent:"space-evenly"}}>
        <span>No Internet Connection</span>
          <IoMdRefreshCircle  onClick={handleRetry}
          style={{
            background: "none",
            border: "none",
            color: "white",
            cursor: "pointer",
            fontSize: "16px",
          }} />
      </div>,
      {
        position: "bottom-left",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: false,
        closeButton:false,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
        toastId: "no-internet",
        style: {
          color: "#fff",
          fontSize: "16px",
          borderRadius:"4px",
        },
         icon: <img src={logoimg} className=" " style={{width:"30px"}}/> ,
      }
    );
  } else {
    toast.dismiss("no-internet");
  }

},[useInternet])

useEffect(() => {
  const location = window.location.href;
  const textcompile = "https://compile.trackhrapp.com/";

  if (!location.includes(textcompile) && process.env.NODE_ENV === "production") {
    console.clear();

    console.log = () => {};
    console.warn = () => {};
  }
}, []);


useEffect(() => {
  AntModal.destroyAll();
}, [location.pathname]);
  return (

    <div className="app">
     <Routes>
          <Route path="/login" element={<Loginpage />} />
          <Route element={<ProtectedRoute />}>
              <Route element={<SideBar />}>
              <Route index element={<Home />} />
              <Route path="home" element={<Home />}/>
              <Route path="todo" element={<KeepAliveWrapper id={`todo-${location.search || "tododefault"}`}><Todomain /></KeepAliveWrapper>} />
              <Route path="profile" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><UserProfile /></Suspense> } />
              <Route path="referus" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><Referscreen /></Suspense>} />
              <Route path="tutorials" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><Tutorialscreen /></Suspense>} />
              <Route path="activity" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><Activities /></Suspense>} />
              <Route path="activityhistory" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><History /></Suspense>} />
              <Route path="leaves" element={<Leave/>} />
              <Route path="subordinates" element={<ListView />}/>
              <Route path="approvals" element={<Approvals/>} />
              <Route path="console" element={<KeepAliveWrapper key={"console"}><Mainpage/></KeepAliveWrapper>} />
              <Route path="hierarchy" element={ <Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><Hierarchy/></Suspense>} />
              <Route path="rightsmanagement" element={<Rightsmanagement/>} />
              <Route path="organisationsettings" element={<Settings/>} />
              <Route path="livelocationsetting" element={<Livelocationsetting/>} />
              <Route path="holiday" element={<Holiday/>} />
              <Route path="groupmaster" element={<Groupmaster/>} />
              <Route path="bulkimportmaster" element={<Bulkmaster/>} />
              <Route path="kpipendency" element={ <KeepAliveWrapper id={`kpipendency-${location.search || "kpipendencydefault"}`}><Kpipendency /></KeepAliveWrapper>} />
              <Route path="kpidetails" element={<Kpidetails/>} />
              <Route path="kpilist" element={<KpiList/>} />
              <Route path="kpiadd" element={<KpiAdd/>} />
              <Route path="workhistory" element={<Workhistory/>} />
              <Route path="broadcast" element={<BroadcastsWithRouter/>} />
              <Route path="payroll" element={ <KeepAliveWrapper id="payroll"><Dashboardmain/></KeepAliveWrapper>} />
              <Route path="userconfiguration" element={<Userconfig/>} />
              <Route path="report" element={ <KeepAliveWrapper id="report"><Allreports/></KeepAliveWrapper>} />
              <Route path="/dailywork" element={ <KeepAliveWrapper id="DailyworkReport"><DailyWorkReportWithRouter /></KeepAliveWrapper>} />
              <Route path="/tasktiming" element={<KeepAliveWrapper id="TasktimingreportWithRouter"><TasktimingreportWithRouter  /></KeepAliveWrapper>} />
              <Route path="/taskcoasting" element={<KeepAliveWrapper id="TaskcoastingReportWithRouter"><TaskcoastingReportWithRouter /></KeepAliveWrapper>} />
              <Route path="/leaderboard" element={<KeepAliveWrapper id="leaderboard-report"> <LeaderboardReportWithRouter /></KeepAliveWrapper> } />
              <Route path="/calendar" element={<CalendarReport/>} />
              <Route path="/dynamicreport" element={<DynamicReportWrapper />} />
              <Route path="/locationtimeline" element={<Locationtimeline />} />
              <Route path="/livelocationsummary" element={<Livelocationsummary />} />
              <Route path="/approvermanagement" element={<Approvermanagement />} />
              <Route path="/novachatbot"/>
              <Route path="/redflag" element={<KeepAliveWrapper id={`redflags-${location.search || "default"}`}><Redflag /></KeepAliveWrapper>} />
              <Route path="/expense" element={<ExpenseScreen/>} />
              <Route path="/fieldpass" element={<ExpenseScreen/>} />
              <Route path="/mypayslip" element={<Mypayslips/>} />
<Route path="/attendance" element={<AttendanceCalendar/>}/>
              <Route path="/shiftmanagement" element={<KeepAliveWrapper key={"ShiftManagement"}><ShiftManagement/></KeepAliveWrapper>} />
              <Route path="/shiftmaster" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><Shiftmaster/></Suspense>} />
              <Route path="/mysubscriptions" />
              <Route path="/attendancemachine" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><AttendanceMachine/></Suspense>} />
              <Route path="/addactivity" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><Addactivity/></Suspense>} />
              <Route path="/editactivity" element={<Addactivity/>} />
              <Route path="/meetings" element={<KeepAliveWrapper id={`meetings-${location.search || "defaultmeeting"}`}><Meetings/></KeepAliveWrapper>} />
              <Route path="/addmeeting" element={<Addmeeting/>}/>
              <Route path="/tickets" element={<KeepAliveWrapper id={`tickets-${location.search || "default"}`}><TicketNew /></KeepAliveWrapper> } />
              <Route path="/addticket" element={<Suspense
    fallback={
      <div style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <Loader/>
      </div>
    }
  ><Addticket/></Suspense>} />
            </Route>
          </Route>
        </Routes>
         <ToastContainer />

{
  isloading && <Modal centered show={isloading} onHide={()=>setisloading(false)}>
          <Modal.Body>
            <Loader/>
          </Modal.Body>
         </Modal>
}
                 {isviewattachment && attachmentdata != null && <ViewComponent passid={attachmentdata?.attachmentId} filenames={attachmentdata?.filename} fileExt={attachmentdata?.fileext} closeModal={() => setisviewattachment(false)} isViewModalOpen={isviewattachment} />}


{(ismeeting && meetinginfo) && <Editmeeting show={ismeeting} meetingInfo={meetinginfo} hide={()=>setismeeting(false)}/>}

<AddTeamQrModal
  show={showQrModal}
  onHide={() => setShowQrModal(false)}
  value={qrData}
  caption="Scan this code to add a team member"
/>
    </div>

  );
}
export default App;